export const CSRF_STATE_KEY = 'CSRFState';

function makeKey(subKey?: string) {
    if (!subKey) {
        return CSRF_STATE_KEY;
    }
    return `${CSRF_STATE_KEY}.${subKey}`;
}

export function setCSRFState(CSRFState: string, subKey?: string): void {
    localStorage.setItem(makeKey(subKey), CSRFState);
}

export function getCSRFState(subKey?: string): string {
    return localStorage.getItem(makeKey(subKey)) ?? '';
}

export function clearCSRFState(subKey?: string): void {
    localStorage.removeItem(makeKey(subKey));
}
